export const UPLOAD_EMPLOYEE_PERSONAL_DOCUMENTS =
  "UPLOAD_EMPLOYEE_PERSONAL_DOCUMENTS";

export const ASSIGN_NEW_AUTHORITY = "ASSIGN_NEW_AUTHORITY";
